import React, { Component } from 'react';
import { Modal, Tabs, Button, Spin, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import BatchTransfer from './BatchTransfer';
import { connect } from 'react-redux';
import { saveParams, saveSearchParams } from '../../../actions/departmentActions';

const { TabPane } = Tabs;

class Detail extends Component {
    state = {
        panes: [{
            title: '科室点评',
            key: 'department',
            content: null,
        }, {
            title: 'PI团队点评',
            key: 'piTeam',
            content: null,
        }, {
            title: '研究者点评',
            key: 'researcher',
            content: null,
        }],
        activeKey: '',
        visible: false,
        record: {},
        params: {},
        data: [],
    }

    show = (record) => {
        this.setState({
            record,
            params: {},
            visible: true,
        }, () => {
            this.handleTabsChange('department');
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            activeKey: '',
            params: {},
            data: [],
        });
    }

    loadData = () => {
        const { activeKey, record: { reviewDepartmentId, reviewPiId, reviewResearcherId } } = this.state;
        let url;
        const params = {};
        if (activeKey === 'department') {
            params.reviewDepartmentId = reviewDepartmentId;
            url = API_URL.hospital.queryReviewDepartmentLogById;
        } else if (activeKey === 'piTeam') {
            params.reviewPiId = reviewPiId;
            url = API_URL.hospital.queryReviewPiLogById;
        } else {
            params.reviewResearcherId = reviewResearcherId;
            url = API_URL.hospital.queryReviewResearcherLogById;
        }
        this.setState({ loading: true }, () => {
            this.updatePanes();
        });
        const options = {
            method: 'POST',
            url,
            data: params,
            dataType: 'json',
            doneResult: res => {
                const { log } = res;
                const { details = [], updateTime = '-', employeeCode, userCompellation = '-' } = log || {};
                this.setState({
                    loading: false,
                    data: details,
                    params: {
                        employeeCode,
                        userCompellation,
                        updateTime: updateTime ? updateTime.slice(0, 10) : '',
                    },
                }, () => {
                    this.updatePanes();
                });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新字段',
        dataIndex: 'updateField',
        key: 'updateField',
        width: 130,
    }, {
        title: '更新前',
        dataIndex: 'updateBefore',
        key: 'updateBefore',
        width: 220,
    }, {
        title: '更新后',
        dataIndex: 'updateAfter',
        key: 'updateAfter',
    }]

    updatePanes = () => {
        const { data, panes, params, activeKey } = this.state;
        const { updateTime, employeeCode, userCompellation } = params;
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = (
                    <div className="cont-cont" style={{margin: 20}}>
                        <div style={{ marginBottom: 16 }}>
                            更新日期：{updateTime}
                            <span className="ant-divider" />
                            更新者：{userCompellation}{employeeCode ? `(${employeeCode})` : ''}
                        </div>
                        <TableC
                            data={data}
                            scrollY={280}
                            columns={this.getColumns()}
                            pagination={false}
                        />
                    </div>
                );
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.loadData();
        });
    }

    render() {
        const { panes, loading, activeKey, visible } = this.state;
        return (
            <Modal
                title="查看更新明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="680px"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >   
                <div style={{ padding: 20 }}>
                    <Spin spinning={loading}>
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)}
                        </Tabs>
                    </Spin>
                </div>
            </Modal>
        )
    }
}

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'departmentSymbol' && params['departmentSymbol'] === 'Empty') {
            params.departmentReviewTime = '';
        } else if (key === 'piSymbol' && params['piSymbol'] === 'Empty') {
            params.piReviewTime = '';
        } else if (key === 'researcherSymbol' && params['researcherSymbol'] === 'Empty') {
            params.researcherReviewTime = '';
        }
        this.props.onChange(params, key);
    }

    render() {
        const { params, ...rest } = this.props;
        const filters = [{
            name: '科室点评更新时间',
            type: 'inputGroup',
            group: [{
                key: 'departmentSymbol',
                type: 'select',
                typeProperty: {
                    style: { width: 70 },
                    list: [
                        { label: '大于', value: 'GreatThan' },
                        { label: '为空', value: 'Empty' },
                    ],
                }
            }, {
                key: 'departmentReviewTime',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 100 },
                    disabled: params['departmentSymbol'] === 'Empty'
                }
            }]
        }, {
            name: 'PI团队点评更新时间',
            type: 'inputGroup',
            group: [{
                key: 'piSymbol',
                type: 'select',
                typeProperty: {
                    style: { width: 70 },
                    list: [
                        { label: '大于', value: 'GreatThan' },
                        { label: '为空', value: 'Empty' },
                    ],
                }
            }, {
                key: 'piReviewTime',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 100 },
                    disabled: params['piSymbol'] === 'Empty'
                }
            }]
        }, {
            name: '研究者点评更新时间',
            type: 'inputGroup',
            group: [{
                key: 'researcherSymbol',
                type: 'select',
                typeProperty: {
                    style: { width: 70 },
                    list: [
                        { label: '大于', value: 'GreatThan' },
                        { label: '为空', value: 'Empty' },
                    ],
                }
            }, {
                key: 'researcherReviewTime',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 100 },
                    disabled: params['researcherSymbol'] === 'Empty'
                }
            }]
        }, {
            name: '医院名称',
            key: 'hospital',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'hospitalName',
                style: {width: 160},
                placeholder: '输入医院名称检索',
                params: {limit: 20},
                url: API_URL.hospital.hospitalList,
                config: { id: 'hospitalId', name: 'hospitalName', show: 'codeSitecourtyardArea' }
            }
        }, {
            name: '科室',
            key: 'departmentLocalName',
            type: 'input',
        }, {
            name: '医院主管',
            key: 'directorUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 160},
                placeholder: '输入姓名或工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '科室leader',
            key: 'jsChargeUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 160},
                placeholder: '输入姓名或工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '与津石是否有合作',
            key: 'isCooperation',
            type: 'select',
            typeProperty: {
                list: [{ label: '是', value: '1'}, { label: '否', value: '0'}],
            },
        }];
        return (
            <FilterBasic filters={filters} params={params} {...rest} onChange={this.handleChange} />
        )
    }
}

class CommentLog extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        curParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(curParams);
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryFillingRateList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {...searchParams},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const params = this.splitParams(curParams);
        const url = API_URL.hospital.exportFillingRateList;
        ExportUtil.export({ ...sortParams, ...params }, null, url);
    }

    batchTransfer = () => {
        this.batchTransferRef.show();
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    filterDate = (text) => text ? text.slice(0, 10) : '';

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            fixed: 'left',
            width: 160,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            fixed: 'left',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 100,
        }, {
            title: '省份',
            dataIndex: 'hospitalProvince',
            key: 'hospitalProvince',
            width: 100,
        }, {
            title: '城市',
            dataIndex: 'hospitalCity',
            key: 'hospitalCity',
            width: 100,
        }, {
            title: '科室',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            width: 100,
        }, {
            title: '医院主管',
            dataIndex: 'hospitalChargeUser',
            key: 'hospitalChargeUser',
            width: 100,
        }, {
            title: '科室leader',
            dataIndex: 'hospitalDepartmentUserName',
            key: 'hospitalDepartmentUserName',
            width: 100,
            render: (text, record) => {
                const { hospitalDepartmentUserName, hospitalDepartmentUserCode } = record;
                return hospitalDepartmentUserName ? `${hospitalDepartmentUserName}[${hospitalDepartmentUserCode}]` : '';
            },
        }, {
            title: '与津石是否有合作',
            dataIndex: 'isCooperation',
            key: 'isCooperation',
            width: 120,
        }, {
            title: '科室点评',
            children: [{
                title: '填写率',
                dataIndex: 'departmentFillingRateShow',
                key: 'departmentFillingRateShow',
                width: 90,
            }, {
                title: '最近更新时间',
                dataIndex: 'departmentReviewTime',
                key: 'departmentReviewTime',
                width: 90,
                render: this.filterDate,
            }, {
                title: '最近更新者',
                dataIndex: 'departmentReviewUpdateUser',
                key: 'departmentReviewUpdateUser',
                width: 120,
                render: (text, record) => {
                    const { departmentReviewUpdateUserCode } = record;
                    return text ? `${text}(${departmentReviewUpdateUserCode})` : '';
                },
            }]
        }, {
            title: 'PI团队点评',
            children: [{
                title: '填写率',
                dataIndex: 'piFillingRateShow',
                key: 'piFillingRateShow',
                width: 90,
            }, {
                title: '最近更新时间',
                dataIndex: 'piReviewTime',
                key: 'piReviewTime',
                width: 90,
                render: this.filterDate,
            }, {
                title: '最近更新者',
                dataIndex: 'piReviewUpdateUser',
                key: 'piReviewUpdateUser',
                width: 120,
                render: (text, record) => {
                    const { piReviewUpdateUserCode } = record;
                    return text ? `${text}(${piReviewUpdateUserCode})` : '';
                },
            }]
        }, {
            title: '研究者点评',
            children: [{
                title: '填写率',
                dataIndex: 'researcherFillingRateShow',
                key: 'researcherFillingRateShow',
                width: 90,
            }, {
                title: '最近更新时间',
                dataIndex: 'researcherReviewTime',
                key: 'researcherReviewTime',
                width: 90,
                render: this.filterDate,
            }, {
                title: '最近更新者',
                dataIndex: 'researcherReviewUpdateUser',
                key: 'researcherReviewUpdateUser',
                width: 120,
                render: (text, record) => {
                    const { researcherReviewUpdateUserCode } = record;
                    return text ? `${text}(${researcherReviewUpdateUserCode})` : '';
                },
            }]
        }, {
            title: '确认时间',
            dataIndex: 'confirmDate',
            key: 'confirmDate',
            width: 100,
            render: this.filterDate,
        }, {
            title: '确认人',
            dataIndex: 'confirmUser',
            key: 'confirmUser',
            width: 160,
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            width: 120,
            fixed: 'right',
            render: (text, record) => {
                const { userId } = sessionStorage;
                const { depJsChargeUserId, confirmFlag } = record;
                const isDepDirector = userId == depJsChargeUserId;
                    return <span>
                        <a disabled={!confirmFlag} onClick={() => this.singleConfirm(record)}>确认</a>
                        <span className="ant-divider" />
                        <a onClick={() => this.comment({...record, isDepDirector})}>点评信息</a>
                        <span className="ant-divider" />
                        <a onClick={() => this.showDetail(record)}>查看更新明细</a>
                    </span>
                return 
            }
        }];
        return columns;
    }

    singleConfirm = (record) => {
        const { hospitalDepartmentId } = record;
        const options = {
            method: 'POST',
            url: API_URL.hospital.confirmFillingRate,
            data: {
                hospitalDepartmentId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    comment = (record) => {
        const { pagination, searchParams } = this.state;
        const { isCharge, isDepDirector, hospitalId, hospitalName, departmentLocalName, hospitalDepartmentId } = record;
        const params = {
            hospitalId,
            hospitalName,
            hospitalDepartmentId,
            isAdd: isCharge === 1 || isDepDirector,
            departmentName: departmentLocalName,
            showCommentLog: true,
        }
        this.props.saveParams({ params });
        this.props.saveSearchParams({
            pagination,
            searchParams,
        })
        location.href = '#/hospital/commentInfo';
    }

    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showDetail = (record) => {
        this.detailRef.show(record);
    }

    render() {
        const { data, loading, pagination, searchParams } = this.state;
        const { curRole } = sessionStorage;
        return (
            <div className="main">
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    buttons={[
                        curRole !== 'CRC' && <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>,
                        <Button key="batchTransfer" type="primary" onClick={this.batchTransfer} style={{marginLeft: 8}}>批量确认</Button>,
                        <Button
                            key="back"
                            type="primary"
                            onClick={() => this.props.showCommentLog(false)}
                            style={{ marginLeft: 8, background: '#62cf96', border: '1px solid #00a854' }}
                        >返回</Button>
                    ]}
                />
                <Spin spinning={loading}>
                    <TableC
                        data={data}
                        className="commentLog"
                        columns={this.getColumns()}
                        rowKey="contractBackRecordId"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </Spin>
                <Detail ref={el => this.detailRef = el} />
                <BatchTransfer ref={el => this.batchTransferRef = el} loadData={this.loadData}/>
            </div>
        );
    }
}
const mapStateToDispatch = state => ({
    feedBack: state.departmentState.feedBack,
    pagination: state.departmentState.pagination,
    searchParams: state.departmentState.searchParams,
});

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: params => dispatch(saveParams(params)),
        saveSearchParams: params => dispatch(saveSearchParams(params)),
    }
}

export default connect(mapStateToDispatch, mapDispatchToProps)(CommentLog);


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/CommentLog.js